// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Bi6H3","cardsWrap":"styles_cardsWrap__vldpl","emailItem":"styles_emailItem__brg+7"};